<i18n>
{
    "ru": {
        "subscribe": "Подписаться",
        "follow_back": "Подписаться в ответ",
        "you_subscribed": "Вы подписаны",
        "request_send": "Запрос отправлен"
}
}
</i18n>

<template>
    <div class="profile-nav" :class="navClasses">

        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            v-for="(item, index) in items"
            :key="index"
            :to="item.route"
            class="profile-nav__item">

            <a @click.prevent="handleAuth(item)" :href="href">
                <svg-icon v-if="item.iconName"
                    class="profile-nav__item-icon"
                    :name="item.iconName"/>

                <span class="profile-nav__item-text">
                    {{ item.title }}
                    <span v-if="item.counter" class="profile-nav__count">
                        ({{ item.counter }})
                    </span>
                </span>
            </a>
        </router-link>

        <div
            v-if="showSubscribe"
            @click="subscribe"
            class="profile-nav__item">

            <svg-icon
                class="profile-nav__item-icon"
                :name="computedIcon"/>

            <span v-if="isFollowing && !isSubscribed" class="profile-nav__item-text">
                {{ $t('follow_back') }}
            </span>

            <span v-else-if="isSubscribed && isRequestSend" class="profile-nav__item-text">
                {{ $t('request_send') }}
            </span>

            <span v-else-if="isSubscribed" class="profile-nav__item-text">
                {{ $t('you_subscribed') }}
            </span>

            <span v-else class="profile-nav__item-text">
                {{ $t('subscribe') }}
            </span>
        </div>
    </div>
</template>

<script>
import get from "lodash/get";

export default {
    name: "ProfileNavButtonsRow",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        mode: {
            type: String,
            default: 'column'
        },
        user: {
            type: Object,
            default: () => {}
        },
        isFollowing: {
            type: Boolean,
            default: false
        },
        isSubscribed: {
            type: Boolean,
            default: false
        },
        isRequestSend: {
            type: Boolean,
            default: false
        },
        showSubscribe: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        navClasses() {
            return {
                'profile-nav_column': this.mode === 'column',
                'profile-nav_row': this.mode === 'row',
            }
        },
        computedSubscribeMode() {
            if(this.isRequestSend) return 'cancel_request';

            return this.isSubscribed ? 'unsubscribe' : 'subscribe'
        },
        computedIcon() {
            let iconName = ''

            if(this.isSubscribed && this.isRequestSend) {
                iconName = 'icon-profile-follow-send'
            } else if(this.isSubscribed) {
                iconName = 'icon-profile-followed'
            } else {
                iconName = 'icon-profile-follow'
            }

            return iconName
        }
    },
    globalBus: {
        'go-to-route'(route) {
            const authUserId = get(this.$auth, 'user.id')
            if(route && route.name) {
                this.$router.push({name: route.name,
                    params: {
                        ...route.params,
                        userId: get(route, 'params.userId', authUserId)
                    }
                })
            }
        },
        'show-subscribe-popup'() {
            this.showPopup('subscribeToUser', {
                user: {
                    name: get(this.user, 'fullName'),
                    photo: get(this.user, 'photo'),
                    statusText: get(this.user, 'statusText')
                },
                mode: this.computedSubscribeMode
            })
        }
    },
    methods: {
        get,
        handleAuth(item) {

            if(item.authRequired) {
                this.$authEmit('go-to-route', item.route);
            }

            else {
                this.$router.push(item.route)
            }

            return false
        },
        subscribe() {
            this.$authEmit('show-subscribe-popup');
        }
    }
}
</script>

<style lang="less">
.profile-nav {
    display: flex;
    flex-flow: column nowrap;

    width: calc(100% - rem(116));

    &__item {
        display: flex;
        align-items: center;

        color: @color-black;
        font-size: rem(14);
        font-weight: 500;
        line-height: 1.5;
        white-space: nowrap;

        padding: rem(10) 0;

        .hover({
            cursor: pointer;
        });

        &-icon {
            fill: @color-black;
            margin-right: rem(12);
            height: rem(20);
            width: rem(20);
            margin-top: rem(-2);

            @media @media-less-375{
                margin-right: rem(5);

                height: rem(15);
                width: rem(15);
            }
        }

        &-text {
            text-overflow: ellipsis;

            width: calc(100% - rem(20));

            overflow: hidden;

            user-select: none;

            @media @media-less-375{
                font-size: rem(13);

                width: calc(100% - rem(15));
            }
        }
    }

    &__count {
        display: inline-block;

        color: @color-violet;

        margin-left: rem(3);
    }

    &_row{
        flex-flow: row;

        .profile-nav__item {
            border: rem(1) solid @color-gray-white;
            font-size: rem(13);

            margin-right: rem(12);
            padding: rem(10) rem(16);

            .hover({
                box-shadow: @menu-desktop-box-shadow-hover;
                .animate(box-shadow);
            });

            &-icon {
                height: rem(15);
                width: rem(15);
            }
        }
    }
}
</style>
